import React from "react";
import {
	makeStyles,
	Box,
	Tooltip,
	Button,
	Typography,
	IconButton,
	SvgIcon,
	Divider,
	Drawer,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PerfectScrollbar from "react-perfect-scrollbar";

import { PopUp } from "../BasePopUp";

import { brokerList } from "src/context/brokerList";
import { useLayout } from "src/utils/customHook";
import BrokerCell from "./BrokerCell";

const useStyles = makeStyles((theme) => ({
	root: {},
	brokerSlot: {
		width: 96,
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: theme.spacing(1),
		padding: "16px",
		display: "flex",
		flexDirection: "column",
		margin: "0px 8px",
	},
	textWrap: {
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	mobileDrawer: {
		width: 400,
		[theme.breakpoints.down("xs")]: {
			width: "100%",
		},
		backgroundColor: theme.palette.background.paper,
	},
	title: {
		display: "flex",
		alignItems: "center",
	},
	close: {
		margin: "-4px -8px",
		color: theme.palette.primary.main,
	},
}));

interface SelectBrokerPopupProps {
	open: boolean;
	onClose: () => void;
	onClickBroker: (brokerName: string, brokerID: string) => void;
}

const SelectBrokerPopup: React.FC<SelectBrokerPopupProps> = ({
	onClose,
	open,
	onClickBroker,
}) => {
	const classes = useStyles();
	const { isDesktop } = useLayout();

	if (!isDesktop)
		return (
			<Drawer
				anchor="left"
				classes={{ paper: classes.mobileDrawer }}
				open={open && !isDesktop}
				onClose={onClose}
				variant="temporary">
				<Box height="100%" display="flex" flexDirection="column">
					<PerfectScrollbar options={{ suppressScrollX: true }}>
						<Box p={3}>
							<>
								<Box className={classes.title}>
									<IconButton
										className={classes.close}
										onClick={() => onClose()}>
										<SvgIcon>
											<CloseIcon />
										</SvgIcon>
									</IconButton>
									<Box mx={2} />
									<Typography>เลือก Broker สำหรับบัญชีหุ้นของคุณ</Typography>
								</Box>
								<Box py={2} />
								{brokerList.map((broker, index) => (
									<Box key={`s8ec${index}s`}>
										<BrokerCell
											brokerName={broker.brokerName}
											brokerID={broker.brokerID}
											handleClickLogin={onClickBroker}
											Icon={broker.icon}
										/>
										<Divider />
									</Box>
								))}
							</>
						</Box>
					</PerfectScrollbar>
				</Box>
			</Drawer>
		);

	return (
		<PopUp
			open={open}
			handleClose={onClose}
			title="เลือก Broker สำหรับบัญชีหุ้นของคุณ">
			<Box display="flex" flexDirection="column" p={3}>
				<PerfectScrollbar options={{ suppressScrollX: true }}>
					<Box display="flex" alignItems="center" justifyContent="center">
						{brokerList.map((broker) => (
							<Tooltip title={broker.brokerName} arrow key={broker.brokerName}>
								<Button
									className={classes.brokerSlot}
									onClick={() =>
										onClickBroker(broker.brokerName, broker.brokerID)
									}>
									<Box
										display="flex"
										flexDirection="column"
										className={classes.textWrap}>
										<Box display="flex" justifyContent="center">
											{broker.icon}
										</Box>
										<Box py={1} />
										<Typography
											variant="subtitle2"
											color="textSecondary"
											noWrap>
											{broker.brokerName}
										</Typography>
									</Box>
								</Button>
							</Tooltip>
						))}
					</Box>
				</PerfectScrollbar>
			</Box>
		</PopUp>
	);
};

export default SelectBrokerPopup;
